"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenMetadataSchema = exports.TokenSwapFeeTypeEnum = void 0;
const zod_1 = require("zod");
var TokenSwapFeeTypeEnum;
(function (TokenSwapFeeTypeEnum) {
    TokenSwapFeeTypeEnum["FEE_ON_TRANSFER"] = "FEE_ON_TRANSFER";
    TokenSwapFeeTypeEnum["FEE_ON_ROUTER_TRANSFER"] = "FEE_ON_ROUTER_TRANSFER";
    TokenSwapFeeTypeEnum["NO_FEE"] = "NO_FEE";
})(TokenSwapFeeTypeEnum || (exports.TokenSwapFeeTypeEnum = TokenSwapFeeTypeEnum = {}));
exports.TokenMetadataSchema = zod_1.z.object({
    permitted: zod_1.z.boolean(),
    domainName: zod_1.z.string().optional().nullable(),
    domainVersion: zod_1.z.string(),
    swapFeeType: zod_1.z.nativeEnum(TokenSwapFeeTypeEnum),
});
